import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './projets.scss';

function Projets() {
  const navigate = useNavigate();
  const [cv, setCv] = useState(false);
  const [nasa, setNasa] = useState(false);
  const [avenir, setAvenir] = useState(false)

  const showCv = () => {
    setCv(true);
  };
  const hideCv = () => {
    setCv(false);
  };
  const showNasa = () => {
    setNasa(true);
  };
  const hideNasa = () => {
    setNasa(false);
  };
  const showAvenir = () => {
    setAvenir(true)
  }
  const hideAvenir = () => {
    setAvenir(false)
  }
  // const indexPageURL = './src/projects/nasa_project/app/index.php';
  // const handleClick = () => {
  //   // Ouvrir la page index.php dans une nouvelle fenêtre ou un nouvel onglet
  //   window.open('./src/projects/nasa_project/app/index.php', '_blank');
  // };
  return (
    <section id="projects">
      <h2 className="fs-40">Projets</h2>
      <article>
        <div className="projects">
          <div
            onMouseOver={showCv}
            onMouseLeave={hideCv}
          >
            <h3>CV en ligne</h3>
            <img className="projet" src="./img/cvv.png" alt="" />
          </div>
          <div
            id="nasa"
            onMouseOver={showNasa}
            onMouseLeave={hideNasa}
          >
            <a href="https://philippegenot.com/nasa" id="goNasa" target="_blank" rel="noreferrer" style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}>
              <h3>My NASA Project</h3>
              <img className="projet" src="./img/nasa_pro.png" alt="" />
            </a>
          </div>
        </div>

        {cv && (
          <div id="cv_para">
            <p>Technos et outils utilisés :</p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> HTML
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> REACT
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> SASS
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Git
            </p>
          </div>
        )}

        {nasa && (
          <div id="nasa_para">
            <p>Connexion à une des API de la NASA pour afficher la dernière exoplanète découverte avec le satellite TESS.</p>
            <p>Technos et outils utilisés :</p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> PHP
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Tailwind
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Postman
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Docker
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Git
            </p>
          </div>
        )}

        <div className="projects2">

          <div
            id="multiprise"
            onClick={() => navigate('/multiprise')}
            style={{ cursor: 'pointer' }}
          >
            <h3>Multiprise Connectée</h3>
            <img className="projet" src="./img/projets/multiprise/presentation.jpg" alt="Multiprise connectée ESP32" />
            <p style={{fontSize:'0.85em', color:'#a0b0cc', marginTop:'0.5em', textAlign:'center'}}>Construction d'une multiprise connectée</p>
          </div>

          <div style={{ cursor: 'pointer' }}>
            <a href="https://www.vers-lavenir.com/" target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
              <h3>Vers l'Avenir</h3>
              <img className="projet" src="./img/projets/vers-lavenir.webp" alt="Vers l'Avenir" />
              <p style={{fontSize:'0.85em', color:'#a0b0cc', marginTop:'0.5em', textAlign:'center'}}>vers-lavenir.com</p>
            </a>
          </div>

          <div style={{ cursor: 'pointer' }}>
            <a href="https://www.axel-genot.com" target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
              <h3>Axel Genot</h3>
              <img className="projet" src="./img/projets/axel-genot.webp" alt="Axel Genot" />
              <p style={{fontSize:'0.85em', color:'#a0b0cc', marginTop:'0.5em', textAlign:'center'}}>axel-genot.com</p>
            </a>
          </div>

        </div>
      </article>
    </section>
  );
}

export default Projets;
